import { useState, useEffect } from "react";
import { Link, SvgIcon, Popper, Button, Paper, Typography, Divider, Box, Fade, Slide } from "@material-ui/core";
import "./switchLang.scss";

import { useTranslation } from 'react-i18next';

const langText = {
  'en': 'EN',
  'hk': '繁',
  'fr': 'Français',
  'kr': '한국어',
}

function SwitchLang() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = "lang-popper";

  const switchLanguage = (target) => {
    i18n.changeLanguage(target)
  }

  return (
    <Box
      component="div"
      onMouseEnter={e => handleClick(e)}
      onMouseLeave={e => handleClick(e)}
      id="ohm-menu-button-hover"
    >
      <Button id="ohm-menu-button" size="large" variant="contained" color="secondary" title="IND" aria-describedby={id}>
        <Typography>{langText[currentLang] || 'EN'}</Typography>
      </Button>

      <Popper id={id} open={open} anchorEl={anchorEl} placement="bottom-start" transition>
        {({ TransitionProps }) => {
          return (
            <Fade {...TransitionProps} timeout={100}>
              <Paper className="ohm-menu" elevation={1}>
                  <Box className="add-tokens">
                    <Button
                      size="large"
                      variant="contained"
                      color="secondary"
                      onClick={() => switchLanguage('hk')}
                    >
                      <div className="flex justify-content-between align-items-center">
                        <Typography>繁</Typography>
                      </div>
                    </Button>

                    <Button
                      variant="contained"
                      size="large"
                      color="secondary"
                      onClick={() => switchLanguage('en')}
                    >
                      <div className="flex justify-content-between align-items-center">
                        <Typography>EN</Typography>
                      </div>
                    </Button>

                    <Button
                      variant="contained"
                      size="large"
                      color="secondary"
                      onClick={() => switchLanguage('fr')}
                    >
                      <div className="flex justify-content-between align-items-center">
                        <Typography>FR</Typography>
                      </div>
                    </Button>

                    <Button
                      variant="contained"
                      size="large"
                      color="secondary"
                      onClick={() => switchLanguage('kr')}
                    >
                      <div className="flex justify-content-between align-items-center">
                        <Typography>한국어</Typography>
                      </div>
                    </Button>
                  </Box>
              </Paper>
            </Fade>
          );
        }}
      </Popper>
    </Box>
  );
}

export default SwitchLang;
